// extracted by mini-css-extract-plugin
export default {"body":"body-l8h3iCOJ"};